<template>
    <div class="more-info-div">
      <banner :on-banner-clicked="openMoreInfo">
        <template v-slot:content>
          <div class="content">
            <div>
              <div><img :src="require('@/assets/icons/star-white.svg')"/></div>
              <div class="text">חודש התנסות חינם לנרשמים עכשיו!</div>
            </div>
            <div><icon icon-name="arrow_back_ios_new" size="24px" color="$riseup_black"/></div>
          </div>
        </template>
      </banner>
    </div>
</template>

<script>

import Segment from '@/Segment';
import BrowserInfo from '@/mixins/BrowserInfo';
import BaseUI from 'base-ui';
import { mapActions } from 'vuex';
import Banner from '@/base-components/Banner';
import TrialExplanationModal
  from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup-v2/steps/TrialExplanationModal';

export default {
  name: 'SignupBanner',
  mixins: [BrowserInfo],
  components: {
    Icon: BaseUI.Icon,
    Banner,
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    openMoreInfo() {
      Segment.trackUserGot('TrialExplanationClicked');
      Segment.trackUserGotToPixel('TrialExplanationClicked');
      this.openModal({
        component: TrialExplanationModal,
      });
    },
  },
};

</script>
<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '@/scss/mixins';

.more-info-div {
  width: 100%;
  padding: 25px 25px 0 25px;

  .content {
    margin: 15px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    div {
      display: flex;
      align-content: space-between;
      justify-content: center;
      align-items: center;
    }

    .text {
      font-size: 16px;
      line-height: 24px;
      color: $riseup_black;
      font-family: SimplerPro;
      font-weight: bold;
      margin: 0px 10px;
    }

    img {
      display: block;
    }
  }
}

</style>
